import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import ListFrequentlyAskedQuestions from './components/ListFrequentlyAskedQuestions'
import './index.scss'

const faqData = [
  {
    question: 'Dịch vụ nhắc nhở, tra cứu phạt nguội giao thông là gì? ',
    answer:
      'Dịch vụ nhắc nhở, tra cứu phạt nguội giao thông trên Viettel Money giúp bạn tự động kiểm tra vi phạm giao thông (phạt nguội) và gửi thông báo qua SMS 2 tuần một lần'
  },
  {
    question: 'Dịch vụ có thay thế CSGT không?',
    answer: 'Không. Đây là dịch vụ hỗ trợ tra cứu thông tin từ nguồn chính thống, không thay thế thông báo chính thức từ cơ quan chức năng.'
  },
  {
    question: 'Các bước tra cứu phạt nguội như thế nào? ',
    answer: [
      'Bước 1: Truy cập App Viettel Money',
      'Bước 2: Truy cập icon Tra cứu phạt nguội',
      'Bước 3: Chọn phương tiện tra cứu và nhập biển số xe',
      'Bước 4: Nhận kết quả tra cứu mới nhất'
    ]
  },
  {
    question: 'Việc tra cứu kết quả phạt nguội trên Viettel Money có mất phí không?',
    answer:
      'Không, việc tra cứu là hoàn toàn miễn phí. Bạn có thể lựa chọn đăng kí gói nhắc nhở tự động (có phí) để tránh phát sinh nộp phạt muộn các lỗi vi phạm giao thông.'
  },
  {
    question: 'Nếu phương tiện của tôi bị ghi nhận vi phạm, tôi có cần tự vào app kiểm tra lại không hay chỉ cần chờ SMS thông báo từ Viettel Money?',
    answer:
      'Trong trường hợp bạn đã đăng ký gói nhắc nhở tự động (có tính phí), bạn sẽ nhận được kết quả quét vi phạm từ Viettel Money 2 tuần một lần. Điều này đồng nghĩa với việc bạn không cần tự tra cứu thủ công.'
  },
  {
    question: 'Tôi có thể huỷ gói dịch vụ đã đăng ký không?',
    answer: 'Bạn có thể huỷ gia hạn dịch vụ bất kỳ lúc nào'
  },
  {
    question: 'Tôi có thể đăng ký nhắc nhở tự động cho nhiều phương tiện không? ',
    answer: 'Có, bạn có thể đăng ký và gia hạn nhiều lần cho các phương tiện khác nhau trên ứng dụng Viettel Money.'
  },
  {
    question: 'Tôi có thể nộp phạt nguội như thế nào?',
    answer: [
      'Để đóng tiền phạt nguội, bạn có thể thực hiện nhanh chóng ngay tại nhà qua mạng (online) hoặc đến nộp trực tiếp tại cơ quan chức năng.',
      '1. Nộp online:',
      '- Cổng Dịch vụ công Quốc gia: Tra cứu, nộp tiền và đăng ký nhận giấy tờ tại nhà.',
      '- Cổng Dịch vụ công Bộ Công an: Nộp tiền trực tiếp và nhận kết quả.',
      '2. Nộp trực tiếp:',
      '- Kho bạc Nhà nước hoặc Ngân hàng thương mại: Nộp tại nơi Kho bạc mở tài khoản (thông tin ghi trên quyết định xử phạt).',
      '- Đến trực tiếp cơ quan Công an: Phòng CSGT/Công an nơi cư trú hoặc nơi phát hiện vi phạm.',
      '- Nộp qua Bưu điện (VNPost): Đăng ký với cơ quan công an khi nhận biên bản và nộp tại bưu điện gần nhất.',
      'Lưu ý: Nộp trực tiếp cho CSGT chỉ áp dụng nếu lỗi vi phạm có mức phạt thấp (dưới 250.000 đồng với cá nhân, 500.000 đồng với tổ chức).'
    ]
  }
]

export default function FAQ() {
  return (
    <div>
      <LayoutPartner headerTitle="Câu hỏi thường gặp">
        <div className="FAQ">
          <div className="FAQ_list">
            <ListFrequentlyAskedQuestions faqData={faqData} />
          </div>
        </div>
      </LayoutPartner>
    </div>
  )
}
